var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18,9.2c-0.1,0.4-0.2,0.7-0.4,1c-0.5,0.7-1.5,1-2.3,0.6c-0.8-0.3-1.3-1.2-1.2-2c0.1-0.9,0.8-1.7,1.7-1.8 c1.1-0.2,2.1,0.6,2.3,1.6c0,0,0,0.1,0,0.1C18,8.9,18,9.1,18,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0,9c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2C0.9,11,0,10.1,0,9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11,9c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2C10.1,7,11,7.9,11,9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.b556669c666c50c11e59a002bf021c1b.svg";
export { ForwardRef as ReactComponent };